import React from 'react';
import styled from '@emotion/styled';
import { Link, type LinkProps } from 'react-router-dom';

type SizeType = 'small' | 'medium' | 'large';

interface StyledLinkProps extends LinkProps {
  size: SizeType;
}

interface CustomLinkProps {
  link: any;
  size: SizeType;
}

const MyLink = styled(Link)<StyledLinkProps>(props => ({
  fontSize: props.size === 'small' ? '14px' : '16px',
  color: '#071B3A',
  fontWeight: 500,
  textDecoration: 'none',
  transition: '.2s color',
  '&:hover': {
    color: '#6948eb',
  },
}));

export const CustomLink = ({ link, size }: CustomLinkProps) => (
  <MyLink key={link.link} to={link.link} target="_blank" size={size}>
    {link.altText ?? link.text}
  </MyLink>
);
